// This file will contain all of the enums
// for all environments

export enum Environments {
  LOCAL,
  DEV,
  UAT,
  PROD
}
